import { AfterViewInit, ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
// import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { Product, ProductScope, ProductService, RoutingService, TranslatePipe } from '@spartacus/core';
import { CurrentProductService, ProductSummaryComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { NgIf, NgFor, AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-product-info-detail',
    templateUrl: './kn-br-product-info-detail.component.html',
    styleUrls: ['./kn-br-product-info-detail.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, AsyncPipe, TranslatePipe]
})
export class KnBrProductInfoDetailComponent extends ProductSummaryComponent implements AfterViewInit, OnDestroy {
  show = true;
  index;
  openedPanels = ['panel1'];
  pdpProductData;
  subscription: Subscription;
  product$: Observable<Product | null> = this.currentProductService
    .getProduct([ProductScope.DETAILS])
    .pipe(tap((_) => {
      this.pdpProductData =_;
      if(this.pdpProductData.isAccesories === true) {
        this.hideTheSection()
      }
      this.knBrCommonService.setSpinner(false)}));
  constructor(
    protected service: CurrentProductService,
    protected productService: ProductService,
    protected routingService: RoutingService,
    private knBrCommonService: KnBrCommonService
  ) {
    super(service);
    //     this.subscription = this.routingService.getRouterState().subscribe((state) => {
    //       if (state.state.params['productCode'])
    // tslint:disable-next-line: max-line-length
    // // TODO:Spartacus - Method 'ProductService.reload' was removed. Please use the reloading triggers configuration instead (see https://sap.github.io/spartacus-docs/loading-scopes/#reloading-triggers for more).
    //         // this.productService.reload(state.state.params['productCode'], ProductScope.DETAILS);
    //     });
    this.knBrCommonService.setSpinner(false);
  }

  // showHide($event: NgbPanelChangeEvent, acc) {
  //   const idx = $event.panelId;
  //   if (!acc.isExpanded($event.panelId)) {
  //     this.openedPanels = [];
  //     this.show = true;
  //     this.openedPanels.push(idx);
  //     this.index = idx;
  //   } else {
  //     let index = this.openedPanels.indexOf(idx);
  //     this.openedPanels.splice(index, 1);
  //     this.show = false;
  //   }
  // }

  shouldProductandTechnicalDocumentationDisplay() {
    if(this.pdpProductData) {
      const product = this.pdpProductData;
      if (
        product.assetName ||
        product.assetNameEs ||
        product.assetNameFr ||
        product.productSellSheetName ||
        product.productSellSheetNameEs ||
        product.productSellSheetNameFr ||
        product.safetyAssetName ||
        product.safetyAssetNameEs ||
        product.safetyAssetNameFr
      ) {
        return true
      }
      return false;
    }
    return false;
  }
  ngAfterViewInit() {
    const slot = document.querySelector('.CwtTabs');
    if (!slot) { return; }
    const wrapper = document.createElement('div');
    wrapper.classList.add('product-div');
    const parent = slot.parentNode;
    parent.insertBefore(wrapper, slot);
    wrapper.appendChild(slot);
  }
  hideTheSection() {
    setTimeout(() => {
      const productDiv = document.querySelector('.product-div');
      productDiv.classList.add('d-none');
    }, 500);
  }
  ngOnDestroy() {
    // this.subscription.unsubscribe();
  }

}
